import { render, staticRenderFns } from "./ReporteTiempoReal.vue?vue&type=template&id=9452d94a"
import script from "./ReporteTiempoReal.vue?vue&type=script&lang=js"
export * from "./ReporteTiempoReal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports